export type LegacyOutput<T> = T extends void ? () => void : (args: { $event: T }) => void;

export function output<T>() {
  return (event: { $event: T }) => event;
}
